module.exports = __webpack_public_path__ + "img/google.fd634051.svg";